import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
export default function useSharedRecord(records, ready, setRecord) {
  const [params, setParams] = useSearchParams();
  const id = params.get("fiche");
  useEffect(() => {
    if (!ready) return;
    setRecord(
      id ? records.find((row) => String(row._id) === id) || null : null,
    );
  }, [id, records, ready, setRecord]);
  const select = (record) => {
    setRecord(record || null);
    const next = new URLSearchParams(params);
    if (record?._id) next.set("fiche", String(record._id));
    else next.delete("fiche");
    setParams(next);
  };
  return {
    select,
    missing: Boolean(
      ready && id && !records.some((row) => String(row._id) === id),
    ),
  };
}
